// extracted by mini-css-extract-plugin
export default {"container":"SavedSearches_container__q5TZU"};